import React, { useState } from "react";
import Table from "common/components/Table/Table.jsx";
import Button from "common/components/CustomButtons/Button.jsx";

import { withRouter } from "react-router";

import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

import loadContent from "core-module/hoc/loadContent";
import { addNewID } from "core-module/services/ids/actions";
import store from "store";
import * as api from "core-module/services/api";

import SweetAlert from "react-bootstrap-sweetalert";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

import { showAlert } from "../../core-module/services/errorAlert/reducers"

const importedStyle = dashboardStyle;

const styles = {
  ...buttonStyle,
  ...regularFormsStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    }
  },
  buttonIcon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative"
  },
  right: {
    textAlign: "right"
  },
  addAddress: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "15px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const MacRegistrationCard = props => {
  const [alert, setAlert] = useState(null);
  const { classes } = props;

  const deleteRegistration = async bpsid => {
    const handleConfirm = async () => {
      props.setIsLoading(true);
      let endpoint = `user.${props.ids.user}/ipaddr_registermac.${bpsid}`;

      let delNLoadResponse = await api.delNload(
        endpoint,
        `user.${props.ids.user}/ipaddr_count`,
        `user.${props.ids.user}/ipaddr_overview`
      );

      if(delNLoadResponse){
        store.dispatch(addNewID("user", ""));
        store.dispatch(addNewID("user", props.ids.user));
      } else {
        store.dispatch(showAlert("Please try again later"));
      }
    };

    setAlert(
      <SweetAlert
        info
        style={{
          display: "block",
          top: "5%",
          maxWidth: "90%",
          marginTop: "1%"
        }}
        title="Confirmation"
        onConfirm={handleConfirm}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={props.classes.button + " " + props.classes.success}
        cancelBtnCssClass={props.classes.button + " " + props.classes.warning}
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
        showCancel
      >
        <h4>Do you want to delete this IP registration?</h4>
      </SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      <Table
        tableHead={[
          "Type",
          "IP Address",
          "Network Mask",
          "Gateway",
          "MAC address",
          "Description",
          "Actions"
        ]}
        tableData={props.getList(
          (oGet, id) => {
            return [
              oGet("static", "value") ? "Static" : "Dynamic",
              oGet("ip_address"),
              oGet("network_mask"),
              oGet("gateway_address"),
              oGet("mac_address"),
              oGet("description"),
              <div className={classes.actionButtons}>
                <Button
                  color={"success"}
                  simple
                  className={classes.actionButton}
                  onClick={() =>
                    props.selectEdit(
                      id,
                      oGet("ip_address"),
                      oGet("network_mask"),
                      oGet("gateway_address"),
                      oGet("static", "value")
                    )
                  }
                >
                  <Edit className={classes.buttonIcon} />
                </Button>
                <Button
                  key={"deleteButton" + id}
                  color={"danger"}
                  simple
                  className={classes.actionButton}
                  onClick={() => deleteRegistration(id)}
                >
                  <Close className={classes.buttonIcon} />
                </Button>
              </div>
            ];
          },
          () => []
        )}
        customHeadCellClasses={[classes.right]}
        customHeadClassesForCells={[6]}
      />
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("user.session/ipaddr_overview", MacRegistrationCard))
);
